const GeneralConfig = requireAuth => [
  {
    path: '/general-config',
    name: 'GeneralConfig',
    component: () => import('./views/GeneralConfig'),
    beforeEnter: requireAuth
  }
]

export default GeneralConfig



// WEBPACK FOOTER //
// ./src/modules/generalConfig/routes.js